<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 82 100">
    <g :fill="iconColor" fill-rule="evenodd">
      <path
        d="M50.713 67.738v-3.836l-3.224 3.836zM37.918 65.09c.344-.269.516-.643.516-1.122 0-.48-.169-.85-.505-1.112-.336-.262-.797-.392-1.381-.392h-2.61v3.029h2.61c.57 0 1.027-.134 1.37-.403"
      />
      <path
        d="M56.677 67.738v3.051H54.55v3.618h-3.837v-3.618h-7.39v-2.746l7.324-8.892h3.903v8.587h2.127zm-26.685 6.669V59.15h6.84c1.725 0 3.085.443 4.08 1.33 1.008.886 1.512 2.034 1.512 3.443 0 1.41-.504 2.564-1.513 3.465-.994.886-2.354 1.33-4.078 1.33h-2.895v5.688h-3.946zm41.215 19.075H16.07c-2.287 0-4.148-1.85-4.148-4.125v-4.77h51.4c2.384 0 4.316-1.918 4.316-4.288v-26.01c0-2.37-1.932-4.29-4.315-4.29H11.922V10.644c0-2.269 1.861-4.119 4.148-4.119l37.957-.04V20.43c0 4.073 3.325 7.38 7.426 7.38l13.743-.039.155 61.586c0 2.274-1.857 4.125-4.144 4.125zM11.441 59.151h3.925l3.881 5.862 3.903-5.862h3.903v15.256h-3.925V65.1l-2.74 4.097h-2.171l-2.829-4.097v9.306h-3.947V59.15zM56.481 0H16.07C10.166 0 5.36 4.779 5.36 10.643V50H4.316C1.932 50 0 51.92 0 54.289v26.01c0 2.37 1.932 4.288 4.315 4.288h1.046v4.77C5.36 95.227 10.166 100 16.07 100h55.137c5.901 0 10.707-4.773 10.707-10.643V25.19L56.48 0z"
      />
      <path
        d="M42.092 25.235l-12.517-8.517c-.578-.393-1.16-.602-1.644-.602-.936 0-1.515.747-1.515 1.997V36.52c0 1.248.578 1.993 1.511 1.993.485 0 1.059-.208 1.638-.603l12.523-8.517c.805-.548 1.251-1.286 1.251-2.08 0-.791-.44-1.53-1.247-2.078"
      />
    </g>
  </svg>
</template>

<script>
  export default {
    name: 'icon-mp4',
    props: {
      width: {
        type: [Number, String],
        default: 82
      },
      height: {
        type: [Number, String],
        default: 100
      },
      iconColor: {
        type: String,
        default: 'currentColor'
      }
    }
  };
</script>
